import { useTranslate } from "hooks/useTranslate";

type DisplayedItem = {
  checkboxContent?: {
    title?: string;
    fileName?: string;
    fromScrivito?: boolean;
  }[];
};

export const useGetFileNameOrTitle = () => {
  const translate = useTranslate();
  const getFileNameOrTitle = (
    reportTitle: string,
    displayedItems: string | DisplayedItem[],
  ) => {
    if (Array.isArray(displayedItems)) {
      for (const item of displayedItems) {
        if (item.checkboxContent) {
          for (const contentItem of item.checkboxContent) {
            if (contentItem.title === reportTitle) {
              if (contentItem.fromScrivito) {
                return contentItem.title;
              }
              return contentItem.fileName;
            }
          }
        }
      }
    }
    return translate(reportTitle);
  };
  return getFileNameOrTitle;
};
